
import './ChooseOffersLocalization.css';
import CloseModal from '../../CommonFunctions/closeModal';
import { useAtom } from 'jotai';
import { useFilteredCity, useFilteredDistrict, useFilteredStreet } from '../../../../data/GlobalStates';
import { useCountryFilter, useCityFilter, useShowPopUpModal, useModalVersion, useModalInfo } from '../../../../data/GlobalStates';

const ChooseOffersLocalization = () => {

    const [ FilteredCity, setFilteredCity ] = useAtom(useFilteredCity);
    const [ FilteredDistrict, setFilteredDistrict ] = useAtom(useFilteredDistrict);
    const [ FilteredStreet, setFilteredStreet ] = useAtom(useFilteredStreet);
    const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
    const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
    const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);

    const saveSelectedCityFilter = (e) => {
      setFilteredCity (e.target.value)
};

    const saveSelectedDistrictFilter = (e) => {
      setFilteredDistrict (e.target.value)
};

    const saveSelectedStreetFilter = (e) => {
      setFilteredStreet (e.target.value)
};

    const ClearAdressFilters = (e) => {
      setFilteredStreet('')
      setFilteredCity('')
      setFilteredDistrict('')
};

  
    return (
        <div id='EditUserFields'>
        <div id='CountriesList'>

         <p className='FilterContainerTitle'>Miasto:</p>
          <input id='TitleInput' className='OfferDetailsInputs' placeholder='' onChange={saveSelectedCityFilter} value={FilteredCity || ''}></input>

         <p className='FilterContainerTitle'>Dzielnica:</p>
           <input id='TitleInput' className='OfferDetailsInputs' placeholder='' onChange={saveSelectedDistrictFilter} value={FilteredDistrict || ''}></input>

         <p className='FilterContainerTitle'>Ulica:</p>
           <input id='TitleInput' className='OfferDetailsInputs' placeholder='' onChange={saveSelectedStreetFilter} value={FilteredStreet || ''}></input>

        </div>
        <div id='ConfirmBtn' onClick={ClearAdressFilters}>Wyczyść filtry</div>
     <div id='ConfirmBtn' onClick={() => CloseModal(setShowPopUpModal, setModalVersion, setModalInfo)}>OK</div>
  </div>
    )
}

export default ChooseOffersLocalization;


